import "./App.scss";
import RoutesConfig from "./config/routesConfig";
import { AuthProvider } from "./context/AuthProvider";
import { LoaderProvider } from "./context/LoaderProvider";

function App() {
  return (
    <LoaderProvider>
      <AuthProvider>
        <RoutesConfig />
      </AuthProvider>
    </LoaderProvider>
  );
}

export default App;
